import React from 'react';
import { useTranslation } from 'react-i18next';
const A11YMenuBar = () => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "a11y-action-bar" },
        React.createElement("div", { className: "container" },
            React.createElement("a", { href: "#maincontent" },
                React.createElement("span", null, t('navigation.aria.gotomaincontent'))),
            React.createElement("a", { href: "#footer" },
                React.createElement("span", null, t('navigation.aria.gotofooter'))))));
};
export default A11YMenuBar;
